import axios from "../../axiosInstance/axiosInstance";
import apiUrlOne from "../../utils.js/Config";

export const getReviewQuestions = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/reviews/questions`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createReviewQuestion = async (data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/reviews/questions`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateReviewQuestion = async (id, data) => {
    try {
        const response = await axios.put(`${apiUrlOne}/reviews/questions/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteReviewQuestion = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/reviews/questions/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getReviewQuestionById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/reviews/questions/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// API functions for reviews
export const getAllReviews = async (params = {}) => {
    try {
        const response = await axios.get(`${apiUrlOne}/reviews/`, { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getPlatformRatingSummary = async (params = { limit: 100 }) => {
    try {
        const response = await axios.get(`${apiUrlOne}/reviews/platform-rating-summary`, { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getReviewById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/reviews/review-by-id/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// PATCH /reviews/:id/status (e.g. { "status": "publish" } or { "status": "reject" })
export const updateReviewStatus = async (id, data) => {
    try {
        const response = await axios.patch(`${apiUrlOne}/reviews/${id}/status`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// POST /reviews/:id/reply (e.g. { "replayDescription": "..." })
export const replyToReview = async (id, data) => {
    try {
        const response = await axios.post(`${apiUrlOne}/reviews/${id}/reply`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteReviewPhoto = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/reviews/review-photos/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
